function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_27",
  "data-name": "Group 27",
  transform: "translate(-1577 -1985)"
}, React.createElement("rect", {
  id: "Rectangle_16",
  "data-name": "Rectangle 16",
  width: 100,
  height: 100,
  rx: 12,
  transform: "translate(1577 1985)",
  fill: "#3b5998"
}), React.createElement("path", {
  id: "Forma_1",
  "data-name": "Forma 1",
  d: "M66.682,18.013,58.286,18c-9.431,0-15.525,6.279-15.525,16v7.376H34.32A1.323,1.323,0,0,0,33,42.7V53.384a1.323,1.323,0,0,0,1.32,1.325h8.44V81.675A1.322,1.322,0,0,0,44.081,83H55.093a1.323,1.323,0,0,0,1.32-1.325V54.71h9.869a1.322,1.322,0,0,0,1.32-1.325V42.7a1.324,1.324,0,0,0-1.321-1.326H56.414V35.119c0-3.005.713-4.531,4.611-4.531h5.656A1.323,1.323,0,0,0,68,29.261V19.338a1.323,1.323,0,0,0-1.318-1.325Z",
  transform: "translate(1577 1985)",
  fill: "#fff",
  fillRule: "evenodd"
}));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.8af341f1.svg";
export { ForwardRef as ReactComponent };